export function isUltraLightLoggedIn() {
    return document.cookie.split("; ").some((cookie) => cookie === "__ulleli=true");
}

export function isUserLoggedIn() {
    return window.REBELMOUSE_BOOTSTRAP_DATA.isUserLoggedIn || isUltraLightLoggedIn();
}

export function updateLoggedIn(value, context) {
    window.REBELMOUSE_BOOTSTRAP_DATA.isUserLoggedIn = value;
    if (context && context.settings) {
        context.settings.isUserLoggedIn = value;
    }
}
